const CONTENTFUL_CDN_REG = /(downloads|images)\.ctfassets\.net/;
const SKIP_EXT_REG =
  /\.(svg|webp|pdf|mp4|mov|avi|webm|mkv|zip|docx?|xlsx?|csv|json|txt)(\?|$)/i;
const SKIP_CONTENT_TYPES = ['image/svg+xml', 'image/webp'];

export function isContentfulImageUrl(url) {
  return typeof url === 'string' && CONTENTFUL_CDN_REG.test(url);
}

export default function optimizeContentfulImageUrl(url, contentType) {
  if (!url || !isContentfulImageUrl(url)) return url;
  if (contentType) {
    if (
      !contentType.startsWith('image/') ||
      SKIP_CONTENT_TYPES.includes(contentType)
    ) {
      return url;
    }
  } else if (SKIP_EXT_REG.test(url)) {
    return url;
  }

  const [base, existingQuery] = url.split('?');
  const params = new URLSearchParams(existingQuery || '');
  if (!params.has('fm')) params.set('fm', 'webp');
  if (!params.has('q')) params.set('q', '80');
  return `${base}?${params.toString()}`;
}
